import { AccountEffects } from './account.effects';
import { NavMenuEffects } from './navmenu.effects';

export const EFFECTS = [AccountEffects, NavMenuEffects];

export { AccountEffects, NavMenuEffects };
